
<div #indicator (click)="this.showZonesEditor()" class="current-zone">
  <div class="header">Current Zone</div>
  <div class="value">{{ this.portfolioCurrentZoneData?.currentZone || 'N/A' }}</div>
</div>


<ets-zone-levels-popover
    #popover
    [targetElement]="indicator"
    [symbol]="'SPX'"
    [currentZoneData]="this.portfolioCurrentZoneData"
    (zoneChanged)="this.onChange()"
>
</ets-zone-levels-popover>

<!-- components/zone-editor/zone-editor.component.html -->
<dx-popup
    #popup
    (onHidden)="onPopupHidden()"
    (onShown)="onPopupShown()"
    [(visible)]="visible"
    [dragEnabled]="true"
    [height]="650"
    [resizeEnabled]="false"
    [showCloseButton]="true"
    [showTitle]="true"
    [width]="500"
    title="Current Zone Editor"
>

  <div class="zone-editor-content">
    <div class="content-wrapper">
      <!-- Support/Resistance Levels Section -->
      <div class="section">
        <!-- Loading indicator -->
        <dx-load-indicator
          [height]="60"
          [visible]="loading"
          [width]="60"
        >
        </dx-load-indicator>

        <div class="section-title top">
<!--          <h4 class="title">Current Zone Template</h4>-->
          <div class="prices">

            <div class="price zone" *ngIf="this.selectedTemplateType === 'Type 1'">
              <div class="label">Current Zone</div>
              <div class="value">{{ this.selectedTemplateCurrentZone }}</div>
            </div>

            <div class="price close">
              <div class="label">Close Price</div>
              <div class="value">{{this.closePrice}}</div>
            </div>

          </div>
        </div>

        <div class="template-selector">
          <!-- CR-20260904-001, Zones Z6: only the granted types are offered (BR-Z1). -->
          <div class="type">
            <div class="btn type" *ngIf="this.isZoneTypeAvailable('Type 1')">
              <dx-button text="Type 1" (onClick)="this.onTemplateTypeSelected('Type 1')"
                         [type]="this.selectedTemplateType === 'Type 1' ? 'default' : null"
                         width="100%"
              ></dx-button>
            </div>
            <div class="btn type" *ngIf="this.isZoneTypeAvailable('Type 2')">
              <dx-button text="Type 2" (onClick)="this.onTemplateTypeSelected('Type 2')"
                         [type]="this.selectedTemplateType === 'Type 2' ? 'default' : null"
                         width="100%"
              ></dx-button>
            </div>
            <!-- CR-20260913-001: the generated-ladder type. -->
            <div class="btn type" *ngIf="this.isZoneTypeAvailable('Type 3')">
              <dx-button text="Type 3" (onClick)="this.onTemplateTypeSelected('Type 3')"
                         [type]="this.selectedTemplateType === 'Type 3' ? 'default' : null"
                         width="100%"
              ></dx-button>
            </div>
            <div class="no-zone-type-grant" *ngIf="this.availableZoneTypes.length === 0">
              No zone type is assigned to your user.
            </div>
          </div>
          <div class="template">
            <dx-select-box placeholder="Select Template..."
                           [items]="this.templateList"
                           displayExpr="name"
                           [value]="this.selectedTemplate"
                           (onValueChanged)="this.onTemplateSelected($event)"
                           fieldTemplate="field"
                           [disabled]="!this.isTypeSelected"
            >
              <div *dxTemplate="let data of 'field'">
                <dx-text-box [value]="data?.name" readOnly="true"></dx-text-box>
              </div>
            </dx-select-box>
          </div>
        </div>

        <dx-scroll-view #levelsScroll>

          <!-- CR-20260913-001: a Type 3 template has no level list. Its ladder is generated by the
               backend from these parameters: a grid at Starting Price + n x Zone Spacing with no
               ends, each line with a band of +/- Bracket Size; the ladder shown is Levels Each
               Side around the portfolio's CURRENT zone (owner ruling 2026-09-15). -->
          <ng-container *ngIf="this.isTemplateSelected && this.isType3Selected">
            <div class="type3-parameters">
              <div class="config-row">
                <label>Starting Price:</label>
                <dx-number-box
                  (onValueChanged)="this.onType3ParameterChange('startingPrice', $event.value)"
                  [format]="'#,##0.##'"
                  [min]="0"
                  [showSpinButtons]="false"
                  [value]="this.selectedTemplateData?.type3?.startingPrice"
                  [inputAttr]="this.inputAttrs"
                ></dx-number-box>
              </div>
              <div class="config-row">
                <label>Zone Spacing:</label>
                <dx-number-box
                  (onValueChanged)="this.onType3ParameterChange('zoneSpacing', $event.value)"
                  [format]="'#,##0.##'"
                  [min]="0"
                  [showSpinButtons]="false"
                  [value]="this.selectedTemplateData?.type3?.zoneSpacing"
                  [inputAttr]="this.inputAttrs"
                ></dx-number-box>
              </div>
              <div class="config-row">
                <label>Bracket Size:</label>
                <dx-number-box
                  (onValueChanged)="this.onType3ParameterChange('bracketSize', $event.value)"
                  [format]="'#,##0.##'"
                  [min]="0"
                  [showSpinButtons]="false"
                  [value]="this.selectedTemplateData?.type3?.bracketSize"
                  [inputAttr]="this.inputAttrs"
                ></dx-number-box>
              </div>
              <div class="config-row">
                <label>Levels Each Side:</label>
                <dx-number-box
                  (onValueChanged)="this.onType3ParameterChange('levelsEachSide', $event.value)"
                  [format]="'#,##0'"
                  [min]="1"
                  [max]="100"
                  [showSpinButtons]="true"
                  [value]="this.selectedTemplateData?.type3?.levelsEachSide"
                  [inputAttr]="this.inputAttrs"
                ></dx-number-box>
              </div>
              <div class="config-row">
                <label>Consecutive X closes:</label>
                <dx-number-box
                  (onValueChanged)="this.onType3ParameterChange('numOfCloses', $event.value)"
                  [max]="30"
                  [min]="1"
                  [showSpinButtons]="true"
                  [value]="this.selectedTemplateData?.type3?.numOfCloses"
                  [inputAttr]="this.inputAttrs"
                ></dx-number-box>
              </div>
              <p class="hint">
                The zone starts at the Starting Price and moves to another line once the
                configured number of consecutive closes land within that line's bracket.
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="this.isTemplateSelected && !this.isType3Selected">
            <!-- Table Header -->
            <div class="table-header">
              <div class="col-sequence">#</div>
              <div class="col-price">Level Price</div>
              <div class="col-type" *ngIf="this.selectedTemplateType === 'Type 1'">Type</div>
              <div class="col-actions"></div>
            </div>

            <!-- Table Body -->
            <div class="table-body">
              <div *ngFor="let row of this.selectedTemplateData?.levels;"
                class="table-row">

                <!-- Sequence Number -->
                <div class="col-sequence">{{ row.sequenceNumber }}</div>

                <!-- Price Input -->
                <div class="col-price">
                  <dx-number-box
                    (onValueChanged)="onPriceChange(row, $event.value)"
                    [format]="'#,##0'"
                    [showSpinButtons]="false"
                    [value]="row.price"
                    [inputAttr]="this.inputAttrs"
                  ></dx-number-box>
                </div>

                <!-- Level Type Select -->
                <div class="col-type" *ngIf="this.selectedTemplateType === 'Type 1'">
                  <dx-text-box readOnly="true"
                               [value]="this.getLevelTypeText(row)"
                               [inputAttr]="this.getInputAttrsForLevelType(row)"
                  ></dx-text-box>

                </div>

                <!-- Remove Button -->
                <div class="col-actions">
                  <dx-button
                    (onClick)="removeRow(row)"
                    hint="Remove level"
                    icon="trash">
                  </dx-button>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!this.isTypeSelected">
            <div class="no-data">
              <p class="text">
                Select Template Type
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="this.isTypeSelected && !this.isTemplateSelected">
            <div class="no-data">
              <p class="text">
                Select Template
              </p>
            </div>
          </ng-container>


        </dx-scroll-view>

      </div>

      <!-- Consecutive Closes Section -->
      <div class="section close-add">
        <!-- Type 3 carries its own consecutive-closes box inside its parameter block. -->
        <div class="col config" *ngIf="!this.isType3Selected">
          <h4 class="section-title">Configuration</h4>
          <div class="config-row">
            <label>Consecutive X closes:</label>
            <dx-number-box
              (onValueChanged)="this.onNumOfClosesChange($event.value)"
              [max]="30"
              [min]="1"
              [showSpinButtons]="true"
              [value]="this.selectedTemplateData?.settings?.numOfCloses"
              [disabled]="!this.isTemplateSelected"
              [inputAttr]="this.inputAttrs"
            ></dx-number-box>
          </div>
        </div>

        <div class="col" *ngIf="!this.isType3Selected">
          <!-- Add Button (not for Type 3: its ladder is generated) -->
          <div class="add-button-container">
            <dx-button
              (onClick)="addRow()"
              icon="plus"
              text="Add Level"
              type="default"
              [disabled]="this.isAddLevelButtonDisabled"
            ></dx-button>
          </div>
        </div>
      </div>

      <!-- Manage Templates      -->
      <div class="section manage-buttons">
        <div class="crud">
          <div class="btn new">
            <dx-button text="New" width="100%" (onClick)="this.onNewTemplateClicked()"
                       [disabled]="this.isNewButtonDisabled"
            ></dx-button>
          </div>
          <div class="btn save">
            <dx-button text="Save" width="100%" (onClick)="this.onSaveTemplateClicked()"
                       [disabled]="this.isSaveButtonDisabled"
            ></dx-button>
          </div>
          <div class="btn save-as">
            <dx-button text="Save As..." width="100%" (onClick)="this.onSaveTemplateClicked(true)"
                       [disabled]="this.isSaveAsButtonDisabled"
            ></dx-button>
          </div>
          <div class="btn delete">
            <dx-button text="Delete" width="100%" (onClick)="this.onDeleteTemplateClicked()"
                       [disabled]="this.isDeleteButtonDisabled"
            ></dx-button>
          </div>
        </div>
        <div class="btn assign">
          <hr class="separator">
          <dx-button text="Assign Templates" width="100%"
                     (onClick)="this.showAssignTemplatesDialog()">
          </dx-button>
        </div>

      </div>

    </div>
  </div>
</dx-popup>

<!-- Assign Templates -->
<dx-popup #assignTemplatesDialog
          [closeOnOutsideClick]="false"
          [dragEnabled]="true"
          [height]="450"
          [resizeEnabled]="true"
          [showTitle]="true"
          [width]="850"
          title="Assign Templates"
>
  <div #assignTemplatesContainer *dxTemplate="let data of 'content'" class="assign-templates">

    <div class="body">

      <!-- CR-20260904-001, Zones Z6: who may work with which zone type (BR-Z1).
           Owner ruling 2026-09-13: this column comes FIRST, portfolios second; every row is
           offered the same four grants. -->
      <div class="col zone-type-grants" *ngIf="this.canEditZoneTypeGrants">
        <div class="header">
          ZONE TYPE ACCESS
        </div>
        <dx-scroll-view>
          <div class="grant-row" *ngFor="let row of this.zoneTypeGrantRows">
            <div class="user">{{row.userName}}</div>
            <dx-select-box
              [items]="this.zoneTypeChoices"
              [value]="row.zoneType"
              [showClearButton]="true"
              placeholder="No access"
              (onValueChanged)="this.onZoneTypeGrantChanged(row, $event)"
            ></dx-select-box>
          </div>
        </dx-scroll-view>
      </div>
      <div class="col portfolios">
        <div class="header">
          PORTFOLIOS
        </div>
        <dx-scroll-view>
          <dx-list
            (onSelectionChanged)="this.onPortfolioToAssignChanged($event)"
            [items]="this.clientPortfoliosToAssign"
            [selectionMode]="'single'"
            [displayExpr]="'portfolioName'"
            [showSelectionControls]="false"
            [grouped]="true"
          >
          </dx-list>
        </dx-scroll-view>
      </div>
      <div class="col templates">
        <div class="header">
          TEMPLATES
        </div>
        <!-- The list follows the grant of the portfolio's OWNER; the hint explains an empty or
             partly hidden list (owner ruling 2026-09-13). -->
        <div class="templates-hint" *ngIf="this.templatesToAssignHint">
          {{ this.templatesToAssignHint }}
        </div>
        <dx-scroll-view>
          <dx-list
              [items]="this.templatesToAssign"
              [selectionMode]="'none'"
              [showSelectionControls]="false"
              [grouped]="true"
          >
            <div *dxTemplate="let item of 'item'">
              <dx-check-box [(value)]="item.isSelected" [text]="item.name"
                [disabled]="this.isTemplatesToAssignListDisabled(item)"
                            (onValueChanged)="this.onChange()"
              >
              </dx-check-box>
            </div>
          </dx-list>
        </dx-scroll-view>
      </div>

    </div>

    <div class="footer">
      <div class="btn">
        <dx-button
          (onClick)="this.saveTemplatesToAssignChanges()"
          text="Save Changes"
          width="100%"
        >
        </dx-button>
      </div>
      <div class="btn">
        <dx-button (onClick)="this.closeTemplateAssignDialog()"
                   text="Cancel"
                   width="100%"
        ></dx-button>
      </div>
    </div>

    <dx-load-panel
      [position]="{my: 'center', at: 'center', of: assignTemplatesContainer}"
      [visible]="this.templatesToAssignLoading">
    </dx-load-panel>

  </div>
</dx-popup>


<!-- Delete Confirmation -->
<ets-generic-confirmation-dialog #confd
  title="Please Confirm"
></ets-generic-confirmation-dialog>


<ets-generic-input-dialog #genericInputDialog
></ets-generic-input-dialog>